'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.ConsumesPanelContext = exports.Provider = exports.Consumer = exports.defaultValues = exports.types = undefined;

var _react = require('react');

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = {
  inPanel: _react.PropTypes.bool
};

var defaultValues = exports.defaultValues = {
  inPanel: false
};

var _createContext = (0, _react.createContext)(defaultValues),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Consumer = Consumer;
exports.Provider = Provider;
var ConsumesPanelContext = exports.ConsumesPanelContext = (0, _consumerDecoratorFactory2.default)('panel', Consumer);

var propType = exports.propType = _react.PropTypes.shape(types);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/context/PanelContext.js
// module id = 331
// module chunks = 0